module.exports = __webpack_public_path__ + "img/no-data-empty.cb40288c.svg";